module.exports = __webpack_public_path__ + "static/img/enterprise1.d0cb83af.png";